'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import { ProjectPaginator } from 'Components/Blocks/_Legacy'
import {
  Check,
  ClientFeedback,
  Description,
  Features,
  Hero,
  Integrations,
  Stats,
  Team,
  Technologies,
} from 'Components/Sections/_Legacy/Project'
import { Column, Row } from 'Components/UI'
import { ProjectNeighborData, ProjectRecordData } from 'Data/types'

import {
  LANDING_INLINE_PADDINGS,
  LANDING_MAX_CONTENT_WIDTH_PX,
} from 'Constants/Landing'

type Props = {
  data?: {
    project?: ProjectRecordData
    prevProject?: ProjectNeighborData
    nextProject?: ProjectNeighborData
  }
}

// Metadata, JSON-LD and 404 handling live in the server page
// (src/app/work/[slug]/page.tsx); this component only renders the UI.
function Project({ data }: Props) {
  const project = data?.project

  if (!project) return null

  return (
    <PageWrapper secondary>
      <Header />

      <Column alignCenter as="main" fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />

        <Hero data={project} />

        <Column
          alignCenter
          fullWidth
          maxWidth={LANDING_MAX_CONTENT_WIDTH_PX}
          px={LANDING_INLINE_PADDINGS}
        >
          <Description data={project} />

          <Stats projectId={project.id} />

          <Features data={project.headlines} />

          <Integrations projectId={project.id} />

          <ClientFeedback projectId={project.id} />

          <Technologies projectId={project.id} />

          <Team projectId={project.id} />

          <Check data={project.platforms} projectId={project.id} />

          <ProjectPaginator
            nextProject={data?.nextProject}
            prevProject={data?.prevProject}
          />
        </Column>
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default Project
